import { render, staticRenderFns } from "./priceTable.vue?vue&type=template&id=e1b49b08&scoped=true"
import script from "./priceTable.vue?vue&type=script&lang=js"
export * from "./priceTable.vue?vue&type=script&lang=js"
import style0 from "./priceTable.vue?vue&type=style&index=0&id=e1b49b08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b49b08",
  null
  
)

export default component.exports